const addFilter = ({url, filter}) => {
  if(!filter) {
    return url;
  }

  const params = new URLSearchParams();

  if(url.indexOf('?') === -1) {
    url += '?';
  }

  Object.entries(filter).map( e => {
    if (e[1] === undefined) {
      return;
    }
    params.append(e[0], e[1]);
  });

  return url + params.toString();
};

export const FilterService = {
  addFilter,
};
